<script lang="ts" setup>
const { t } = useI18n();
const telestrationStore = useTelestrationStore();

const playlistTitle = computed(() => {
  return telestrationStore.currentPlaylistItem?.title ?? "";
});
</script>

<template>
  <div class="basis-full lg:basis-1/3">
    <div
      class="flex items-center justify-between px-4 py-3"
    >
      <div
        class="light:text-dark-800 h-[23px] truncate text-base font-bold text-black dark:text-white"
      >
        {{ t("pages.videos.telestrations.telestration_side_panel_heading", { playlistTitle: playlistTitle }) }}
      </div>
    </div>
    <UDivider :lighter="true" />
    <div
      class="flex flex-col items-center  justify-between gap-6 px-8 py-10 dark:text-white"
    >
      <UIcon
        name="telestration"
        class="size-8 text-base text-neutral-light-800"
      />
      <p class="text-center text-sm text-neutral-light-800">
        {{ t("pages.videos.telestrations.telestration_side_panel_description") }}
      </p>
    </div>
  </div>
</template>
